import lru from "quick-lru";
import type { ICmsSubscription } from "../entities/cms-subscription/cms-subscription.entity.interface";
import type { ICmsSubscriptionCachedDatasource } from "./cms-subscription-cached.datasource.interface";
import type { ICmsSubscriptionDto } from "../dtos/cms-subscription/cms-subscription.dto.interface";

const CACHE_MAX_AGE_MILLIS = 60_000;
const CACHE_MAX_SIZE = 1;

export class CmsSubscriptionCachedDatasource implements ICmsSubscriptionCachedDatasource {
  private readonly _CACHE_KEY = "cms-subscriptions-list";
  constructor(
    private readonly _cache = new lru<string, ICmsSubscriptionDto[]>({
      maxSize: CACHE_MAX_SIZE,
      maxAge: CACHE_MAX_AGE_MILLIS,
    })
  ) {}

  resetCache(): void {
    this._cache.delete(this._CACHE_KEY);
  }

  private _getCache() {
    return this._cache.get(this._CACHE_KEY);
  }

  public getOrderedSubscriptions(): ICmsSubscriptionDto[] | undefined {
    const data = this._getCache();

    return data;
  }

  public setOrderedSubscriptions(data: ICmsSubscription[]): void {
    this._cache.set(this._CACHE_KEY, data);
  }
}
